/**
 * sessionStorage key namespace for the chat approval-resume state persisted by
 * features/chat/hooks/useApprovalAutoResume. Lives in lib/ (not the feature)
 * so the auth store can sweep it on logout without depending on a feature
 * module: a blocked message is user chat content and must not outlive the
 * session that produced it in a shared browser tab (security review W3, P2).
 */
export const APPROVAL_RESUME_STORAGE_PREFIX = 'vharta:chat:approval-resume:'

export function approvalResumeStorageKey(approvalId: string): string {
  return `${APPROVAL_RESUME_STORAGE_PREFIX}${approvalId}`
}

/** Remove every persisted approval-resume entry. Best-effort: storage may be unavailable. */
export function clearAllApprovalResumeState(): void {
  try {
    const doomed: string[] = []
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i)
      if (key && key.startsWith(APPROVAL_RESUME_STORAGE_PREFIX)) doomed.push(key)
    }
    doomed.forEach((key) => sessionStorage.removeItem(key))
  } catch {
    // sessionStorage unavailable (private mode, SSR, blocked) — nothing to clear.
  }
}
